import Entrance from './images/backdrops/entrance.jpg'
import EntranceM from './images/backdrops/entranceP.jpg'
import LobbyL from './images/backdrops/lobby.jpg'
import LobbyM from './images/backdrops/lobbyP.jpg'
import Exhibition from './images/backdrops/exhibition.jpg'
import Auditorium from './images/backdrops/auditorium.jpg'
import AuditoriumM from './images/backdrops/auditoriumP.jpg'
import NetworkingL from './images/backdrops/networking.jpg'
import NetworkingM from './images/backdrops/networkingM.jpg'
import LobbyMusic from './images/audio/lobby.mp3'
import routes from './routes'
import Gallerium from './images/backdrops/gallerium.jpg'
import infoIcon from './images/info.png'
import door1 from './images/backdrops/door1_close.png'
import door1Hover from './images/backdrops/door1_hover.png'
import door2 from './images/backdrops/door2_close.png'
import door2Hover from './images/backdrops/door2_hover.png'
import door3 from './images/backdrops/door3_close.png'
import door3Hover from './images/backdrops/door3_hover.png'
import door4 from './images/backdrops/door4_close.png'
import door4Hover from './images/backdrops/door4_hover.png'

const dev = {
  // apiUrl: 'https://micomwh.com',
  apiUrl: 'http://localhost:3000',
}

const prod = {
  apiUrl: 'https://micomwh.com',
}

const API_KEYS = {
  amplitude: 'd88dc711a289c4c5688c84eed6951514',
}

const VOLUME_VALUE = 0.4

const config = process.env.NODE_ENV === 'production' ? prod : dev

const assets = {
  entrance: {
    landscape: Entrance,
    portrait: EntranceM,
  },
  lobby: {
    landscape: LobbyL,
    portrait: LobbyM,
  },
  auditorium1: {
    landscape: Auditorium,
    portrait: AuditoriumM,
  },

  exhibition1: Exhibition,
  exhibition2: Exhibition,

  networking: {
    landscape: NetworkingL,
    portrait: NetworkingM,
  },
  gallerium: Gallerium,

  lobbyMusic: LobbyMusic,

}

const layout = {
  auditoriumVid: `
    top: 6%;
    bottom: 42%;
    left: 15%;
    right: 33%;
  `,
}

const lobbyEntries = [
  {
    id: 'auditorium',
    destination: routes.auditorium1,
    entryOpenImage: door1Hover,
    entryCloseImage: door1,
    css: `
      top: 43.4%;
      left: 35.6%;
      right: 56.3%;
      bottom: 36.9%;
    `,
  },
  {
    id: 'exhibition',
    destination: [
      { name: 'Hall A', url: routes.exhibition1 },
      { name: 'Hall B', url: routes.exhibition2 },
      { name: 'Hall C', url: routes.exhibition3 },
    ],
    entryOpenImage: door2Hover,
    entryCloseImage: door2,
    css: `
      top: 43.4%;
      left: 43.5%;
      right: 49%;
      bottom: 36.9%;
    `,
  },
  {
    id: 'networking',
    destination: routes.networking,
    entryOpenImage: door3Hover,
    entryCloseImage: door3,
    css: `
      top: 43.4%;
      left: 51.1%;
      right: 41.2%;
      bottom: 36.9%;
    `,
  },
  {
    id: 'gallerium',
    destination: routes.onDemand,
    entryOpenImage: door4Hover,
    entryCloseImage: door4,
    css: `
      top: 43.4%;
      left: 58.8%;
      right: 33.6%;
      bottom: 36.9%;
    `,
  },
  {
    id: 'helpdesk',
    destination: 0,
    infoImage: infoIcon,
    css: `
      top: 55%;
      left: 20%;
      right: 99%;
      bottom: 60.5%;
    `,
  },
]

export default {
  API_KEYS,
  assets,
  layout,
  lobbyEntries,
  VOLUME_VALUE,

  eventName: 'Malaysia International Virtual Conference on Menopause & Women’s Health',

  ...config,
}
